import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { useInstance } from 'intact-react';
import { useState } from '../../hooks/useState';
import { NOW_START, NOW_END } from './constants';
import { useReceive } from '../../hooks/useReceive';
export function useStep(_ref, _ref2) {
  var maxDate = _ref.maxDate,
    minDate = _ref.minDate;
  var getValueString = _ref2.getValueString,
    getShowString = _ref2.getShowString;
  var instance = useInstance();
  var options = useState(null);
  useReceive(['step', 'min', 'max'], generateOptions);
  function generateOptions() {
    var _instance$get = instance.get(),
      step = _instance$get.step;
    if (step) {
      var data = [];
      var maxValue = maxDate.value || NOW_END;
      var stepValue = parseTime(step);
      var value = minDate.value || NOW_START;
      var push = function push(value) {
        data.push({
          value: getValueString(value),
          label: getShowString(value)
        });
      };
      for (;; value = value.add(stepValue, 'second')) {
        if (value <= maxValue) {
          push(value);
          if (+value === +maxValue) break;
        } else if (data.length) {
          // it the last value is less than maxValue,
          // add the maxValue to the last
          push(maxValue);
          break;
        } else {
          break;
        }
      }
      options.set(data);
    } else {
      options.set(null);
    }
  }
  function parseTime(time) {
    var _context;
    var _time$split$map = _mapInstanceProperty(_context = time.split(':')).call(_context, function (item) {
        return parseInt(item, 10);
      }),
      hours = _time$split$map[0],
      minutes = _time$split$map[1],
      seconds = _time$split$map[2];
    return (hours * 60 + (minutes || 0)) * 60 + (seconds || 0);
  }
  return {
    options: options
  };
}